<template>
  <div>
    <ContentSectionLoader v-show="!loaded" />
    <Transition name="fade">
      <div v-if="loaded">
        <ExportsTable
          v-if="exports.length"
          :exports="exports"
        />
        <div v-if="reports.length">
          <div class="table-responsive">
            <table class="table table-data">
              <thead>
                <tr>
                  <th
                    class="sm:w-1/6"
                    v-text="'Report Name'"
                  />
                  <th
                    class="sm:w-3/6"
                    v-text="'Selected Columns'"
                  />
                  <th v-text="'Applied Filters'" />
                  <th
                    class="sm:w-2/6"
                    v-text="'Actions'"
                  />
                </tr>
              </thead>
              <tbody>
                <MembershipReportRow
                  v-for="report in reports"
                  :key="`report-${report.uuid}`"
                  :report="report"
                  @reportDeleted="handleDeletion"
                  @reportRun="handleRun"
                />
              </tbody>
            </table>
          </div>
        </div>
        <div
          v-else
          class="empty"
        >
          <section>
            <h2 v-text="'There are no membership reports yet.'" />
            <a
              v-can="'edit-membership-reports'"
              :href="'/members/reports/create'"
              v-text="'Create one'"
            />
          </section>
        </div>
      </div>
    </Transition>
    <SelectReportFormatModal
      :open="openSelectReportModal"
      @closeModal="openSelectReportModal = false"
      @downloadReport="downloadReport"
    />
    <AuthCodeModal
      :open="openAuthCodeModal"
      @closeModal="openAuthCodeModal = false"
      @authCodeVerified="authCodeVerified"
    />
  </div>
</template>

<script type="text/babel">
import { kebabCase } from 'lodash'
import { mapActions, mapGetters, mapState } from 'vuex'
import MembershipReportRow from './reports/MembershipReportRow'
import SelectReportFormatModal from './_modals/SelectReportFormatModal'
import ExportsTable from 'Export/Resources/assets/js/components/ExportsTable'

export default {
  name: 'MembershipReports',
  components: {
    MembershipReportRow,
    SelectReportFormatModal,
    ExportsTable,
  },
  data() {
    return {
      loaded: false,
      reportToRunUuid: null,
      reportToRunName: null,
      openSelectReportModal: false,
      openAuthCodeModal: false,
    }
  },
  computed: {
    ...mapGetters({
      reports: 'membershipGetMembershipReports',
      reportIsRunning: 'membershipIsMembershipReportRunning',
    }),
    ...mapState({
      exports: state => state.exports.exports.data,
    }),
  },
  async mounted() {
    await this.$nextTick()

    this.getMembershipReports().then(() => {
      this.getExports({
        params: {
          types: 'report',
        },
      }).then(() => {
        this.loaded = true
      })
    })
  },
  methods: {
    ...mapActions({
      runReport: 'membershipRunMembershipReport',
      getMembershipReports: 'membershipGetMembershipReports',
      getExports: 'exportGetExports',
    }),
    handleDeletion() {
      this.getMembershipReports()
      //TODO add confirmation modal
    },
    handleRun(uuid, name) {
      this.reportToRunUuid = uuid
      this.reportToRunName = name
      this.openAuthCodeModal = true
    },
    authCodeVerified() {
      this.openAuthCodeModal = false
      this.openSelectReportModal = true
    },
    downloadReport(format) {
      this.runReport({
        url: `memberships/reports/${this.reportToRunUuid}/run`,
        parameters: {
          format: format,
        },
        reportName: kebabCase(this.reportToRunName),
      })
    },
  },
}
</script>
